import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import Button from 'srcReact/components/common2/Button'
import Checkbox from 'srcReact/components/common2/Checkbox'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { redirectToPage } from 'srcReact/helpers/history'
import { authenticationActions } from 'srcReact/redux/actions/authentication'
import styles from './styles.module.scss'

function TermsCondition({ updateStep, formState, setFormState }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [agreeMixrTerms, setAgreeMixrTerms] = useState(formState.agreeMixrTerms)
  const [errorAgree, setErrorAgree] = useState(false)

  const {
    authentication: { ssoUser }
  } = useSelector((state) => state)

  useEffect(() => {
    if (ssoUser) {
      setFormState({ ...formState, workplace_invitations: ssoUser.workplace_invitations })
      updateStep('profileEdition')
    }
  }, [ssoUser])

  const handleConfirm = () => {
    if (!agreeMixrTerms) {
      setErrorAgree(true)
      return false
    }
    setFormState({ ...formState, agreeMixrTerms })
    dispatch(authenticationActions.getSSOUserInfo(formState.password))
  }

  const handleCancel = () => {
    redirectToPage(`/auth`)
  }

  return (
    <div className={styles.termsContainer}>
      <div className={styles.linkContainer}>
        <AnchorLink
          isReactLink={false}
          target='_blank'
          className={styles.link}
          path={config.webUrl + '/terms-of-services'}>
          {t('signup.email_module.term')}
        </AnchorLink>
      </div>
      <div className={styles.linkContainer}>
        <AnchorLink
          isReactLink={false}
          target='_blank'
          className={styles.link}
          path={config.webUrl + '/privacy-policy'}>
          {t('signup.email_module.privacy')}
        </AnchorLink>
      </div>
      <div className={styles.agree}>
        <Checkbox
          customClassName={styles.checkBoxAgree}
          checked={agreeMixrTerms}
          onChange={(e) => {
            setAgreeMixrTerms(e.target.checked)
            setErrorAgree(false)
          }}
        />
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div className={styles.agreeTextContainer}>
            {t('signup.email_module.agree')}{' '}
            <a className={styles.terms} href={config.webUrl + '/terms-of-services'} target='_blank'>
              {t('signup.email_module.term')}
            </a>{' '}
            {t('global.and')}{' '}
            <a className={styles.terms} href={config.webUrl + '/privacy-policy'} target='_blank'>
              {t('signup.email_module.privacy')}
            </a>
          </div>
        </div>
      </div>
      {errorAgree && <ErrorMessage text={t('signup.email_module.agree_terms')} className={styles.errorTerms} />}
      <div className={styles.buttonContainer}>
        <Button text={t('signup.email_module.cancel')} handleClick={handleCancel} size='large' style='secondary' />
        <Button
          text={t('signup.email_module.confirm')}
          handleClick={handleConfirm}
          size='large'
          customStyle={styles.confirmButton}
        />
      </div>
    </div>
  )
}

export default TermsCondition
